export default __webpack_public_path__ + "static/media/slp.13ea8743.png";